<div #host class="json-editor__host"></div>
